import { Input, Label, Textarea } from "../../../../../../components"
import { Controller, useFormContext } from "react-hook-form"
import type { DataList } from "../../types"

export function FormSection(props: { isDetail?: boolean; isUpdate?: boolean; action?: string }) {
  const { control } = useFormContext<DataList>()

  return (
    <table className="table">
      <tbody>
        <Controller
          control={control}
          name="religion_code"
          render={({ field, fieldState }) => 
            <tr>
              <td><Label text="CODE" error={Boolean(fieldState.error)} /></td>
              <td>
                <Input 
                  {...field} 
                  placeholder="Input Code"
                  value={field.value ?? ""} 
                  error={fieldState.error?.message} 
                  disabled={props.action === "DETAIL" || props.action === "DELETE"} 
                />
              </td>
            </tr>
          }
        />

        <Controller
          control={control}
          name="religion_name"
          render={({ field, fieldState }) => 
            <tr>
              <td><Label text="RELIGION" error={Boolean(fieldState.error)} /></td>
              <td>
                <Input 
                  {...field} 
                  placeholder="Input Religion" 
                  value={field.value ?? ""} 
                  error={fieldState.error?.message} 
                  disabled={props.action === "DETAIL" || props.action === "DELETE"} 
                />
              </td>
            </tr>
          }
        />

        <Controller
          control={control}
          name="description"
          render={({ field, fieldState }) => 
            <tr>
              <td><Label text="DESCRIPTION" error={Boolean(fieldState.error)} /></td>
              <td>
                <Textarea {...field} value={field.value ?? ""} error={fieldState.error?.message} disabled={props.action === "DETAIL" || props.action === "DELETE"} />
              </td>
            </tr>
          }
        />
      </tbody>
    </table>
  )
}